/**
 * @fileoverview Client Portal Layout Wrapper
 *
 * Top-level layout component for the client portal. Renders the navbar,
 * the routed page content, and a shared version footer below — matching
 * the AdminPortal pattern.
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import ClientDashboard from "../pages/client/ClientDashboard";
import ClientSelections from "../pages/client/ClientSelections";
import ClientDocuments from "../pages/client/ClientDocuments";
import ClientChangeOrders from "../pages/client/ClientChangeOrders";
import ClientUpdates from "../pages/client/ClientUpdates";
import ClientProfile from "../pages/client/ClientProfile";
import VersionFooter from "../components/VersionFooter";
import { OnboardingProvider } from "../onboarding/OnboardingProvider";
import { getClientVersion } from "../config/version";

/**
 * Client portal layout component.
 *
 * @param {Object} props
 * @param {Object} props.user - Firebase auth user object
 * @param {Object} props.userData - User data from Airtable
 * @returns {JSX.Element} Client portal with navbar, routes, and version footer
 */
function ClientPortal({ user, userData }) {
  const project = null;

  return (
    <OnboardingProvider>
      <div className="client-portal">
        <Navbar user={user} userData={userData} project={project} />
        <div className="portal-container">
        <Routes>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route
            path="dashboard"
            element={
              <ClientDashboard
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
          <Route
            path="selections"
            element={
              <ClientSelections
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
          <Route
            path="documents"
            element={
              <ClientDocuments
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
          <Route
            path="change-orders"
            element={
              <ClientChangeOrders
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
          <Route
            path="updates"
            element={
              <ClientUpdates
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
          <Route
            path="profile"
            element={
              <ClientProfile
                user={user}
                userData={userData}
                project={project}
              />
            }
          />
        </Routes>
        </div>
        <VersionFooter version={getClientVersion()} portal="client" />
      </div>
    </OnboardingProvider>
  );
}

export default ClientPortal;
